import React, { useCallback, useEffect } from 'react'
import { Form, Input, Button, Select } from 'antd'
import { connect } from 'dva'
import PageWrapper from '@/components/PageWrapper'
import './Team.module.less'

const { Option } = Select

const layout = {
  labelCol: { span: 3 },
  wrapperCol: { span: 16 },
}

const AddTeam = ({ dispatch, changeTeamStatus, teamList }) => {
  useEffect(() => {
    dispatch({
      type: 'center/getTeamList',
    })
  }, [dispatch])

  const onFinish = useCallback(
    (values) => {
      const formData = new FormData()
      Object.keys(values).forEach((key) => {
        const v = values[key]
        if (v) {
          formData.append(key, values[key])
        }
      })
      dispatch({
        type: 'center/joinTeam',
        payload: {
          params: formData,
        },
      })
    },
    [dispatch]
  )

  return (
    <PageWrapper
      style={{ marginTop: '45px' }}
      subTitle={<span styleName="title">加入团队</span>}
    >
      <Form
        {...layout}
        name="basic"
        labelAlign="left"
        initialValues={{ remember: true }}
        onFinish={onFinish}
        style={{ marginTop: '30px' }}
      >
        <Form.Item
          label="团队名称"
          name="teamId"
          rules={[{ required: true, message: '请选择团队' }]}
        >
          <Select
            placeholder="请选择团队"
            className="team-select"
            showSearch
            filterOption={(input, option) => {
              return option.children.toLowerCase().includes(input.toLowerCase())
            }}
          >
            {teamList.map((it) => (
              <Option key={it.id} value={it.id}>
                {it.name}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          label="队长昵称"
          name="leaderNickname"
          rules={[{ required: true, message: '请输入队长昵称' }]}
        >
          <Input styleName="input" placeholder="请输入队长昵称" />
        </Form.Item>
        <Form.Item
          label="联系电话"
          name="phone"
          rules={[{ message: '请输入联系电话' }]}
          extra="为方便队长联系，请输入您的电话"
        >
          <Input styleName="input" placeholder="请输入联系电话" />
        </Form.Item>

        <div styleName="tips">
          注：加入团队后，一年内不能修改团队，如有特殊情况，可发邮件到security@xiaomi.com
        </div>
        <div style={{ marginTop: '50px' }} styleName="content">
          <Button
            style={{ marginRight: '100px', width: '88px' }}
            type="primary"
            htmlType="submit"
          >
            提交审核
          </Button>
          <Button
            style={{ width: '88px' }}
            onClick={() => changeTeamStatus('table')}
          >
            取 消
          </Button>
        </div>
      </Form>
    </PageWrapper>
  )
}

export default connect(({ center }) => {
  return {
    teamPagination: center.teamPagination,
    teamList: center.teamList,
  }
})(AddTeam)
